import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";
import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/10" data-testid="site-footer">
      <Reveal y={60}>
        <button
          onClick={() => scrollTo("#contact")}
          data-testid="footer-lets-talk"
          className="group block w-full text-left px-6 md:px-12 py-16 md:py-24 hover:bg-volt transition-colors duration-500"
        >
          <span className="font-cabinet font-black uppercase leading-[0.85] tracking-tight text-[16vw] md:text-[10vw] text-outline group-hover:text-obsidian group-hover:[-webkit-text-stroke:0px] transition-all duration-500 block">
            {t("footer.cta")}
          </span>
          <span className="mt-6 inline-flex items-center gap-2 font-jetbrains text-xs uppercase tracking-[0.3em] text-white/40 group-hover:text-obsidian transition-colors duration-500">
            {t("footer.assessment")} <ArrowUpRight size={16} />
          </span>
        </button>
      </Reveal>

      <div className="border-t border-white/10 px-6 md:px-12 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 max-w-[1600px] mx-auto">
        <p className="font-cabinet font-black uppercase tracking-tight">
          Two Shores<span className="text-volt">.</span>{" "}
          <span className="text-white/40 font-medium normal-case">Collegiate</span>
        </p>
        <p className="font-jetbrains text-[10px] md:text-xs uppercase tracking-[0.25em] text-white/40">
          {t("footer.tagline")}
        </p>
      </div>
    </footer>
  );
}
